import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';

import { CSSProperties, useState } from 'react';
import ReactSlick from 'react-slick';

import { AuctionsPromoItem } from '../../types';
import PromotionCard from './promotion-card';

type ArrowProps = {
    className?: string;
    style?: CSSProperties;
    onClick?: () => void;
};

function PrevCarouselArrow(props: ArrowProps) {
    const { className, style, onClick } = props;

    return (
        <button
            id="social-proof-carousel__prev"
            aria-label="Previous Slide"
            className={className + ' kmx-fab kmx-fab--secondary carousel__prev'}
            data-controls="prev"
            onClick={onClick}
            style={{ ...style }}>
            <span className="visually-hidden">Next Slide</span>
            <svg
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
                focusable="false">
                <path d="M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z" />
                <path d="M0-.5h24v24H0z" fill="none" />
            </svg>
        </button>
    );
}

function NextCarouselArrow(props: ArrowProps) {
    const { className, style, onClick } = props;

    return (
        <button
            id="social-proof-carousel__next"
            aria-label="Next Slide"
            className={className + ' kmx-fab kmx-fab--secondary carousel__next'}
            data-controls="next"
            onClick={onClick}
            style={{ ...style }}>
            <span className="visually-hidden">Next Slide</span>
            <svg
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
                focusable="false">
                <path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z" />
                <path d="M0-.25h24v24H0z" fill="none" />
            </svg>
        </button>
    );
}

type Props = {
    promotions: AuctionsPromoItem[];
};

export default function Slider({ promotions }: Props) {
    const [slideIndex, setSlideIndex] = useState(0);

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '10px',
        initialSlide: 0,
        swipeToSlide: true,
        swipe: true,
        fade: false,
        className: 'enable-zoom',
        nextArrow: <NextCarouselArrow />,
        prevArrow: <PrevCarouselArrow />,
        beforeChange: (current: number, next: number) => setSlideIndex(next),
        appendDots: dots => (
            <div>
                <ul style={{ margin: '0px' }}>
                    {dots.map((item, index) => {
                        return <li key={index}>{item.props.children}</li>;
                    })}
                </ul>
            </div>
        ),
        customPaging: (index: number) => (
            <button
                id={`label-slide${index + 1}`}
                aria-labelledby={`label-slide${index + 1}`}
                aria-label={`Slide ${index + 1}`}
                className={index === slideIndex ? 'dot dot-active' : 'dot'}></button>
        ),
        responsive: [
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 700,
                settings: {
                    slidesToShow: 1,
                    nextArrow: <> </>,
                    prevArrow: <> </>,
                },
            },
        ],
    };

    const renderPromotionCardsFor = (promotionArray: Array<AuctionsPromoItem> = []) => {
        return promotionArray.map((promotionData: AuctionsPromoItem, index: number) => (
            <PromotionCard key={index.toString()} {...promotionData} />
        ));
    };

    return <ReactSlick {...settings}>{renderPromotionCardsFor(promotions)}</ReactSlick>;
}
